import { gql } from '@apollo/client'

export const LEAVE_DAY_FIELDS = gql`
  fragment LeaveDayFields on AdminLeaveDay {
    id
    startDate
    endDate
    leaveType
    status
    description
    canUpdate
    canApprove
    canDelete
    staff {
      id
      fullName
    }
  }
`

export const LEAVE_DAYS_QUERY = gql`
  query LeaveDays($page: Int, $per: Int, $staffId: ID, $status: LeaveDayStatusEnum, $startDate: ISO8601Date, $endDate: ISO8601Date) {
    leaveDays(page: $page, per: $per, staffId: $staffId, status: $status, startDate: $startDate, endDate: $endDate) {
      totalCount
      totalPages
      leaveDays {
        ...LeaveDayFields
      }
    }
  }
  ${LEAVE_DAY_FIELDS}
`

export const LEAVE_DAY_QUERY = gql`
  query LeaveDay($id: ID!) {
    leaveDay(id: $id) {
      ...LeaveDayFields
    }
  }
  ${LEAVE_DAY_FIELDS}
`

export const LEAVE_CALENDAR_URL_QUERY = gql`
  query LeaveCalendarUrl {
    leaveCalendarUrl
  }
`

export const CREATE_LEAVE_DAY_MUTATION = gql`
  mutation CreateLeaveDay($startDate: ISO8601Date!, $endDate: ISO8601Date!, $leaveType: LeaveDayLeaveTypeEnum!, $description: String) {
    createLeaveDay(startDate: $startDate, endDate: $endDate, leaveType: $leaveType, description: $description) {
      leaveDay {
        ...LeaveDayFields
      }
      errors {
        key
        message
      }
    }
  }
  ${LEAVE_DAY_FIELDS}
`

export const UPDATE_LEAVE_DAY_MUTATION = gql`
  mutation UpdateLeaveDay($id: ID!, $startDate: ISO8601Date, $endDate: ISO8601Date, $leaveType: LeaveDayLeaveTypeEnum, $description: String, $status: LeaveDayStatusEnum) {
    updateLeaveDay(id: $id, startDate: $startDate, endDate: $endDate, leaveType: $leaveType, description: $description, status: $status) {
      leaveDay {
        ...LeaveDayFields
      }
      errors {
        key
        message
      }
    }
  }
  ${LEAVE_DAY_FIELDS}
`

export const DELETE_LEAVE_DAY_MUTATION = gql`
  mutation DeleteLeaveDay($id: ID!) {
    deleteLeaveDay(id: $id) {
      deletedId
      errors {
        key
        message
      }
    }
  }
`

export const LEAVE_TYPES = ['vacation', 'bussiness', 'sick']

export const LEAVE_STATUSES = ['pending', 'approve', 'no_approve']

export const STATUS_COLORS = {
  pending: 'gold',
  approve: 'green',
  no_approve: 'red'
}

export const MANAGER_ROLES = ['super_admin', 'hr', 'leave_approver']

export const CALENDAR_FEED_ROLES = ['super_admin', 'hr']

export const formatMutationErrors = (errors = []) => errors.map(({ message }) => message).join(', ')
